// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"99":"5317386e","531":"082ab142","1886":"168e0279","1931":"168e0279","3556":"082ab142","4291":"f29a7e6e","7115":"188845f6"}[chunkId] + ".chunk.css";
};